export default __webpack_public_path__ + "static/media/check-inDefault.44dd1891.svg";